import { render, staticRenderFns } from "./SpecialSale.vue?vue&type=template&id=139f5c00&scoped=true&"
import script from "./SpecialSale.vue?vue&type=script&lang=js&"
export * from "./SpecialSale.vue?vue&type=script&lang=js&"
import style0 from "./SpecialSale.vue?vue&type=style&index=0&id=139f5c00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "139f5c00",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/opt/bitnami/apache/htdocs/medapp/web/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardActions } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VImg } from 'vuetify/lib'
import { VSlideYTransition } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VCardTitle,VFlex,VIcon,VImg,VSlideYTransition,VSpacer})
